export const APP_I18N_PREFIX = "features.home.app";

export const APP_I18N_KEYS = {
  footer: "footer"
}


// WEBPACK FOOTER //
// ./src/features/home/constants/i18n/Appi18nConstants.js